import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';

const APP_TIMEZONE = 'America/New_York';

/**
 * Format a date string or Date object in Eastern Time.
 * Uses the same format tokens as date-fns.
 */
export function formatET(date, fmt) {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return '';
  return formatInTimeZone(d, APP_TIMEZONE, fmt);
}

/** True if the calendar day of `date` at HH:mm (Eastern Time) is already past. */
export function isPastET(date, time) {
  if (!date || !time) return false;
  const day = formatInTimeZone(date, APP_TIMEZONE, 'yyyy-MM-dd');
  return fromZonedTime(`${day}T${time}:00`, APP_TIMEZONE) < new Date();
}

export { APP_TIMEZONE };
